module.exports = __webpack_public_path__ + "img/v2k_bildmarke_wortmarke_r_dark.6091d484.svg";